export enum UseCaseLabels {
  AdRevenue = 'Ad Revenue',
  AudienceDevelopment = 'Audience Development',
  BrandedContent = 'Branded Content',
  Ecommerce = 'E-Commerce',
  PaidSubscriptions = 'Paid Subscriptions',
  GoogleDemandGen = 'Google Demand Gen'
}
